/**
 * Created by liujintao on 18/2/27.
 */
import $axios from "axios";
import utils from "@/utils/index";
import _ from "lodash";
var serverDomain = "";
// var lanuage = localStorage.getItem("lang") || "en";
// switch (lanuage) {
//   case "en":
//     lanuage = "en-US";
//     break;
//   case "zh":
//     lanuage = "zh-CN";
//     break;
//   case "ko":
//     lanuage = "ko-KR";
//     break;
//   case "fr":
//     lanuage = "fr-FR";
//     break;
//   case "ja":
//     lanuage = "ja-JP";
//     break;
//   default:
//     serverDomain = "en-US";
// }
// 配合编译工具，指定模式屏蔽log
function API(path) {
  this.path = path;
}
let _ua = navigator.userAgent;

let setEnv = 2;
if (_ua.match(/MicroMessenger/i) == "MicroMessenger") {
  console.log("======微信环境下=======");
  setEnv = 1;
}

_.extend(API.prototype, {
  post: function(data, options) {
    let headers = {
      checkoutToken: options.checkoutToken,
      env: setEnv
    };
    // 如果options.bankAccountListToken存在则请求头添加bankAccountListToken
    if (options.bankAccountListToken) {
      headers.bankAccountListToken = options.bankAccountListToken;
    }
    if (options.timezone) {
      headers["time-zone"] = options.timezone;
    }
    if (options.osType) {
      headers.osType = options.osType;
    }
    const language = localStorage.getItem("lang") || "en-US";
    // 语言 zh-CN 、zh-HK、zh-TW、zh-US、zh-JP、zh-KR、zh-FR
    if (language === "en") {
      headers.language = "en-US";
    } else if (language === "zh") {
      headers.language = "zh-CN";
    } else if (language === "fr") {
      headers.language = "fr-FR";
    } else if (language === "ja") {
      headers.language = "ja-JP";
    } else if (language === "ko") {
      headers.language = "ko-KR";
    }
    if (options.uploadType) {
      headers.uploadType = options.uploadType;
    }
    // 如果bankAccountToken存在则请求头添加bankAccountToken
    if (options.bankAccountToken) {
      headers.bankAccountToken = options.bankAccountToken;
    }
    options = _.extend(options || {}, {
      headers: headers
    });
    // let params = !data.checkoutShow ? data : {};

    data = data || {};
    var url = this.getUrl("post", data);
    return $axios.post(url, data, options);
  },
  get: function(data, options) {
    // options = _.extend(options || {}, {
    //   headers: {
    //     token: utils.cookie.get('token')
    //   }
    // })
    data = data || {};
    var url = this.getUrl("get", data);
    return $axios.get(url + "?" + utils.jsonToSerializer(data), options); // ;
  },
  postOuter: function(data, options) {
    data = data || {};
    var url = this.getUrl("post", data);
    return $axios.post(url, data, options);
  },
  put: function(data, options) {
    // options = _.extend(options || {}, {
    //   headers: {
    //     token: utils.cookie.get('token')
    //   }
    // })
    data = data || {};
    var url = this.getUrl("put", data);
    return $axios.put(url, data, options);
  },
  getUrl: function(method, data) {
    var path =
      method !== "POST" && data && !!data._id
        ? this.path + "/<%=_id%>"
        : this.path;
    var url = this.url || _.template(path)(data);
    return url;
  }
});
API.prototype.server = serverDomain;
var apiMethod = {};
var apiMap = {};
var apiUrlMap = {
  checkoutShow: serverDomain + "/gateway/pay/api/order/checkout/show/v2",
  goPay: serverDomain + "/gateway/pay/api/order/checkout/pay/v2",
  queryOrder: serverDomain + "/gateway/pay/api/order/checkout/query/v2 ",
  verifyPage: serverDomain + "/gateway/pay/api/order/paypal/verify/v2",
  showNoAuthon:
    serverDomain + "/gateway/pay/api/order/checkout/showNoAuthon/v2",
  appleValidateMerchant:
    serverDomain + "/gateway/pay/api/order/airwallex/apple/verify/v2",
  getCardList: serverDomain + "/gateway/pay/api/merchant/user/payToken/list/v2",
  verifyGiact:
    serverDomain + "/gateway/pay/api/order/checkout/accountVerify/v2",
  deleteCard:
    serverDomain + "/gateway/pay/api/merchant/user/payToken/remove/v2",
  reportLog: serverDomain + "/gateway/pay/api/order/ali/log/upload/v2",
  // 订阅收银台
  subscriptionCheckoutShow:
    serverDomain + "/gateway/pay/api/subscription/checkout/web/show",
  subscriptionCheckoutPay:
    serverDomain + "/gateway/pay/api/subscription/checkout/web/subscription",
  subscriptionCheckoutQuery:
    serverDomain +
    "/gateway/pay/api/subscription/checkout/web/querySubscriptionStatus",
  subscriptionGetCardList:
    serverDomain + "/gateway/pay/api/subscription/user/bankAccount/list",
};
apiMap.CodeMap = {
  Success: 0,
  TokenExpired: 20007,
  NoToken: 20001
};
_.each(apiUrlMap, function(path, key) {
  apiMethod[key] = new API(path);
});

apiMap.getServer = function() {
  return API.prototype.server;
};
apiMap.apiMethod = apiMethod;

export default apiMap;
